import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import {
  useGetProfessionalInfoQuery,
  useSaveProfessionalInfoMutation,
} from "../../../../store/professionalInfo";
import IconButton from "../../../iconButton";
import AdminContactInformation from "./AdminContactInformation";
import AdminGeneralInformation from "./AdminGeneralInformation";
import AdminProfileTeam from "./AdminProfileTeam";

const AdminProfileOptimization = () => {
  const [isChange, setIsChange] = useState(false);
  const { data: professionaInfo, refetch: professionalInfoDetail } =
    useGetProfessionalInfoQuery();

  const [updateUser, setUpdatedUser] = useState(professionaInfo?.data);
  const [updatedUserData, setUpdatedUserData] = useState({});

  const [
    saveProfessionalInfo,
    {
      isLoading: infoIsLoading,
      isSuccess: saveIsSuccess,
      isError,
      error,
      data: savedProfessionalData,
    },
  ] = useSaveProfessionalInfoMutation();

  useEffect(() => {
    if (professionaInfo) {
      setUpdatedUser(professionaInfo?.data);
    }
  }, [professionaInfo]);

  const checkIsChangeUser = (userInfo) => {
    let flag = false;
    const keys1 = Object.keys(userInfo);
    const keys2 = Object.keys(professionaInfo?.data);
    if (keys1.length !== keys2.length) {
      flag = true;
    }
    const tempParams = {};
    for (const key of keys1) {
      if (userInfo[key] && userInfo[key] != professionaInfo.data[key]) {
        tempParams[key] = userInfo[key];
        flag = true;
      } else {
        if (updatedUserData[key]) {
          delete updatedUserData[key];
        }
      }
    }
    flag && setUpdatedUserData({ ...updatedUserData, ...tempParams });
    return flag;
  };

  const handleUserChange = (e) => {
    let tempUpdateUser = { ...updateUser };
    if (
      e.target.name === "cell_phone_number" ||
      e.target.name === "office_phone_number"
    ) {
      let updatedPhone = e.target.value.replace(/[-()\s]/g, "");

      if (updatedPhone.length < 11) {
        tempUpdateUser = { ...updateUser, [e.target.name]: updatedPhone };
        setUpdatedUser(tempUpdateUser);
        const isCheck = checkIsChangeUser(tempUpdateUser);
        setIsChange(isCheck);
      }
    } else {
      tempUpdateUser = { ...updateUser, [e.target.name]: e.target.value };
      setUpdatedUser(tempUpdateUser);
      const isCheck = checkIsChangeUser(tempUpdateUser);
      setIsChange(isCheck);
    }
  };

  const handleProfileChange = (file) => {
    const tempUpdateUser = { ...updateUser, photo: file };
    setIsChange(checkIsChangeUser(tempUpdateUser));
    setUpdatedUser(tempUpdateUser);
  };

  const handleSubmit = () => {
    if (updatedUserData && updatedUserData !== {}) {
      updatedUserData["_method"] = "PUT";

      const userFormData = new FormData();
      if (updatedUserData.photo) {
        userFormData.append("_method", "PUT");
        userFormData.append("photo", updatedUserData.photo);

        saveProfessionalInfo(userFormData);
        delete updatedUserData.photo;
      }

      saveProfessionalInfo(updatedUserData);
    }
  };

  return (
    <>
      <AdminGeneralInformation
        professionaInfo={updateUser}
        handleChange={handleUserChange}
        handleProfileChange={handleProfileChange}
      />
      <AdminContactInformation
        professionaInfo={updateUser}
        handleChange={handleUserChange}
        originalProfessionalInfo={professionaInfo?.data}
      />
      <AdminProfileTeam />
      {isChange && (
        <div className="flex items-center gap-5 justify-end md:justify-end mt-[30px] fixed bottom-0 right-0 bg-white py-4 md:py-[30px] px-5 md:px-[35px] w-full">
          <IconButton
            title="Save"
            icon={!isChange && CheckCircleIcon}
            iconClasses="w-6 h-6 text-white"
            classes="text-sm font-black leading-[160%] text-white max-w-[160px] md:max-w-[128px] w-full flex items-center justify-center gap-[6px] bg-primary h-10 rounded-[10px]"
            onClick={handleSubmit}
            buttonLoader={infoIsLoading}
          />
        </div>
      )}
      {/* <div className="flex items-center gap-5 justify-end mt-[30px]">
        <IconButton
          title="cancel"
          icon={XCircleIcon}
          iconClasses="w-6 h-6 text-[#485868]"
          classes="text-sm font-black leading-[160%] text-[#485868] capitalize max-w-[162px] md:max-w-[128px] w-full flex items-center justify-center gap-[6px] bg-[#EBEFF3] h-10 rounded-[10px]"
        />
        <IconButton
          title="save"
          icon={CheckCircleIcon}
          iconClasses="w-6 h-6 text-white"
          classes="text-sm font-black leading-[160%] text-white capitalize max-w-[162px] md:max-w-[128px] w-full flex items-center justify-center gap-[6px] bg-primary h-10 rounded-[10px]"
          // onClick={handleChangePassword}
          // buttonLoader={changePasswordLoader}
        />
      </div> */}
    </>
  );
};

export default AdminProfileOptimization;
